import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

interface ExchangeRateCardProps {
    rate: string;
    lastUpdate: string;
    title?: string;
}

const ExchangeRateCard: React.FC<ExchangeRateCardProps> = ({
    rate = "100,00 Bs.S",
    lastUpdate = "Jueves 17 a las 12:12 a.m",
    title = "Tasa cambiaria dolar"
}) => {
    return (
        <Paper
            elevation={0}
            sx={{
                p: 3,
                borderRadius: 2,
                border: '1px solid #e0e0e0',
                width: '100%'
            }}
        >
            <Typography
                variant="h6"
                component="h2"
                fontWeight="500"
                sx={{ mb: 2 }}
            >
                {title}
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: { xs: 'wrap', sm: 'nowrap' }
                }}
            >
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                        maxWidth: { xs: '100%', sm: '60%' },
                        mb: { xs: 1, sm: 0 }
                    }}
                >
                    Tasa actualizada el {lastUpdate} :
                </Typography>

                <Typography
                    variant="h4"
                    component="div"
                    fontWeight="600"
                    sx={{ ml: { xs: 0, sm: 2 } }}
                >
                    {rate}
                </Typography>
            </Box>
        </Paper>
    );
};

export default ExchangeRateCard;